import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        duration:       Number,
        redirectUrl:    String,
        redirectDelay:  Number,
        redirectAction: { type: String, default: "replace" },
        matchPath:      Boolean
    };

    connect() {
        this.hideTimer = null;
        this.startX = 0;
        this.currentX = 0;
        this.isDragging = false;

        this.startHideTimer();
        this.startRedirectTimer();

        this.element.addEventListener("mouseenter", this.pauseHideTimer.bind(this));
        this.element.addEventListener("mouseleave", this.startHideTimer.bind(this));
        this.element.addEventListener("focusin", this.pauseHideTimer.bind(this));
        this.element.addEventListener("focusout", this.startHideTimer.bind(this));

        this.element.addEventListener("touchstart", this.dragStart.bind(this), { passive: true });
        this.element.addEventListener("touchmove", this.drag.bind(this), { passive: true });
        this.element.addEventListener("touchend", this.dragEnd.bind(this));
    }

    disconnect() {
        this.pauseHideTimer();
        clearTimeout(this.redirectTimer);
    }

    close() {
        this.pauseHideTimer();
        clearTimeout(this.redirectTimer);

        this.element.style.opacity = "0";
        const swipeDistance = this.currentX - this.startX;
        const direction = swipeDistance === 0 ? -1 : Math.sign(swipeDistance);
        this.element.style.transform = `translateX(${direction * 100}%)`;

        setTimeout(() => {
            if (this.element && this.element.parentNode) {
                this.element.remove();
            }
        }, 300);
    }

    startHideTimer() {
        if (this.durationValue === 0) return;
        this.hideTimer = setTimeout(() => {
            this.close();
        }, this.durationValue);
    }

    pauseHideTimer() {
        clearTimeout(this.hideTimer);
    }

    dragStart(event) {
        if (event.touches.length !== 1) return;
        this.isDragging = true;
        this.startX = event.touches[0].pageX;
        this.element.style.transition = "none";
    }

    drag(event) {
        if (!this.isDragging || event.touches.length !== 1) return;
        this.currentX = event.touches[0].pageX;
        const diff = this.currentX - this.startX;
        this.element.style.transform = `translateX(${diff}px)`;
    }

    dragEnd(event) {
        if (!this.isDragging) return;
        this.isDragging = false;

        const swipeThreshold = this.element.offsetWidth / 3;
        const diff = this.currentX - this.startX;

        if (Math.abs(diff) > swipeThreshold) {
            this.close();
        } else {
            this.element.style.transform = "translateX(0px)";
        }
    }

    startRedirectTimer() {
        if (!this.hasRedirectUrlValue) return;

        const delay = this.hasRedirectDelayValue ? this.redirectDelayValue : 1200;
        this.redirectTimer = setTimeout(() => this.performRedirect(), delay);
    }

    performRedirect() {
        if (this.hasMatchPathValue && this.matchPathValue) {
            const currentPath = window.location.pathname.replace(/\/$/, "");
            const targetPath = this.redirectUrlValue.replace(/\/$/, "");

            if (currentPath !== targetPath) {
                console.log(`Path mismatch: staying on ${currentPath}`);
                return;
            }
        }

        this.close();

        if (window.Turbo?.visit) {
            Turbo.visit(this.redirectUrlValue, { action: this.redirectActionValue });
        } else {
            // Fallback for non-turbo environments
            if (this.redirectActionValue === "replace") {
                window.location.replace(this.redirectUrlValue);
            } else {
                window.location.assign(this.redirectUrlValue);
            }
        }
    }
}